export default __webpack_public_path__ + "static/media/twitter_share.1cd044aa.svg";